var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "file-text"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000008926"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.90039 6.59961H5.70039H20.1004",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.3012 6.6V19.2C18.3012 19.6774 18.1115 20.1352 17.774 20.4728C17.4364 20.8104 16.9786 21 16.5012 21H7.50117C7.02378 21 6.56595 20.8104 6.22838 20.4728C5.89081 20.1352 5.70117 19.6774 5.70117 19.2V6.6M8.40117 6.6V4.8C8.40117 4.32261 8.59081 3.86477 8.92838 3.52721C9.26595 3.18964 9.72378 3 10.2012 3H13.8012C14.2786 3 14.7364 3.18964 15.074 3.52721C15.4115 3.86477 15.6012 4.32261 15.6012 4.8V6.6",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.2012 11.0996V16.4996",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.8008 11.0996V16.4996",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteTrash);
export default __webpack_public_path__ + "static/media/whiteTrash.1cd3bc4803e002e13b5f479f3952311d.svg";
export { ForwardRef as ReactComponent };